import { Component, Input, OnInit } from "@angular/core";

export enum availableCode {
  AVAILABLE = "AVAILABLE",
  PROGRESSING = "PROGRESSING",
  NOT_AVAILABLE = "NOT_AVAILABLE"
}

export interface AvailableContent {
  label: string;
  availableCode: availableCode;
}

@Component({
  selector: "app-available-content",
  templateUrl: "./available-content.component.html",
  styleUrls: ["./available-content.component.scss"]
})
export class AvailableContentComponent implements OnInit {
  @Input()
  availableContents: AvailableContent[];

  constructor() {}

  ngOnInit() {}

  getNbAvailableContent(): number {
    return this.availableContents.filter(
      set => set.availableCode === availableCode.AVAILABLE
    ).length;
  }
}
